import {
  LOGIN,
  LOGOUT,
  GET_USER,
  VERIFYPHONENUMBER,
} from "../actions/action.types";

const initialState = {
  user: null,
  isAuthenticated: false,
  userRole: [],
  token: "",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        userRole: action.userRole,
        token: action.token,
        user: action.user,
        isAuthenticated: action.authenticated,
      };
    case GET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case VERIFYPHONENUMBER:
      return {
        ...state,
        isAuthenticated: true,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
